import * as React from 'react';

import { faFileInvoice } from '@fortawesome/pro-regular-svg-icons';
import { DialogDescription } from '@radix-ui/react-dialog';
import { FormattedMessage, useIntl } from 'react-intl';

import { DigitalReceiptCanvas } from 'src/features/statistics/components/DigitalReceiptCanvas.tsx';
import { statisticsMessages } from 'src/features/statistics/utils';
import SquareIcon from 'src/registry/components/blocks/SquareIcon.tsx';
import { Button } from 'src/registry/ui/Button';
import {
    Dialog,
    DialogBody,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogSeparator,
    DialogTitle,
} from 'src/registry/ui/Dialog';
import { generalMessages } from 'src/utils/messages.ts';

interface ViewDigitalReceiptModalProps extends React.HTMLAttributes<HTMLDivElement> {
    digitalReceiptDetails?: string;
    downloadReceipt?: () => void;
}

const ViewDigitalReceiptModal = ({
    children,
    digitalReceiptDetails,
    downloadReceipt,
}: ViewDigitalReceiptModalProps) => {
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
    const { formatMessage } = useIntl();

    return (
        <Dialog open={isModalOpen} onOpenChange={() => setIsModalOpen(!isModalOpen)}>
            {children}
            <DialogContent onOpenAutoFocus={(e) => e.preventDefault()} onCloseAutoFocus={(e) => e.preventDefault()}>
                <DialogHeader>
                    <div className="flex gap-4">
                        <SquareIcon icon={faFileInvoice} />
                        <div>
                            <DialogTitle>{formatMessage(statisticsMessages.digitalReceipt)}</DialogTitle>
                            <DialogDescription>
                                <FormattedMessage {...statisticsMessages.downloadCopyDescription} />
                            </DialogDescription>
                        </div>
                    </div>
                </DialogHeader>
                <DialogSeparator />
                <DialogBody className="flex justify-center">
                    <DigitalReceiptCanvas receiptTextLines={digitalReceiptDetails?.trimEnd().split('\n')} />
                </DialogBody>
                <DialogSeparator />
                <DialogFooter className="flex-row">
                    <Button
                        variant="outline"
                        type="button"
                        className="flex-1"
                        onClick={() => setIsModalOpen(!isModalOpen)}
                    >
                        {formatMessage(generalMessages.cancel)}
                    </Button>
                    <Button onClick={downloadReceipt} className="flex-1">
                        <FormattedMessage {...statisticsMessages.downloadReceipt} />
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export { ViewDigitalReceiptModal };
